import React from 'react';
var LoadingState = function () { return (React.createElement("div", { className: "map-loading" },
    React.createElement("div", { className: "map-loading__spinner" }),
    React.createElement("div", { className: "map-loading__content" },
        React.createElement("div", { className: "skeleton category" }),
        React.createElement("div", { className: "skeleton title" }),
        React.createElement("div", { className: "skeleton description" })))); };
export default LoadingState;
